export default "__VITE_ASSET__Bd6cy2Dd__"